var React = require('react');

function DeleteIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3 1a2 2 0 0 0-2 2v2.228a2 2 0 0 0 1.106 1.789l.561.28L5.849 21.44A2 2 0 0 0 7.8 23h8.4a2 2 0 0 0 1.951-1.561l3.182-14.141.561-.281A2 2 0 0 0 23 5.228V3a2 2 0 0 0-2-2H3zm0 2h18v2.228l-.561.28a2 2 0 0 0-1.057 1.35L16.2 21H7.8L4.618 6.859a2 2 0 0 0-1.057-1.35L3 5.229V3zm4.731 3.834a.75.75 0 1 0-1.462.332l2.5 11a.75.75 0 0 0 1.462-.332l-2.5-11zM12 6.25a.75.75 0 0 1 .75.75v11a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75zm4.269.584a.75.75 0 1 1 1.462.332l-2.5 11a.75.75 0 1 1-1.462-.332l2.5-11z","fill":"#fff"}));
}

DeleteIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = DeleteIcon;

DeleteIcon.default = DeleteIcon;
